module.exports = __webpack_public_path__ + "img/sld.102d4fc9.jpg";